<input [type]='fieldData.type' [value]='fieldData.value' [name]='fieldData.name' [id]='fieldData.id'>
